import type { QueryAccount } from './useAccount'
import { useAccount } from './useAccount'

type CurrentOrganization = NonNullable<QueryAccount['currentOrganization']>

export const useCurrentOrganization = (): CurrentOrganization | null => {
  const { account } = useAccount()

  return account?.currentOrganization ?? null
}

export const useOrganizationId = (): string | null => {
  const organization = useCurrentOrganization()
  return organization?.id ?? null
}
